import * as React from "react";
import { connect } from "react-redux";
import LinkPharmacy from "./LinkPharmacy";
import LinkEmployeeAccount from "./LinkEmployeeAccount";
import LinkMyChartAccount from "./LinkMyChartAccount";
import LinkHealthPlanAccount from "./LinkHealthPlanAccount";
import DartOrWacoAccount from "./DartOrWacoAccount";
import FirstCareAccount from "./FirstCareAccount";
import InsurancePlan from './InsurancePlan';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import LinkAAAccount from "./LinkAAAccount";
import StatusBanner from '../common/StatusBanner';
import SectionLoadingError from "../common/SectionLoadingError";
import { Link } from "react-router-dom";
import * as queryString from 'query-string';
import TryAgainToolTip from '../common/TryAgainToolTip';

class LinkedAccounts extends React.Component {

    constructor(props) {
        super(props);
        this.isMobileQueryValue = Tools.isMobileQuery(props.location);
        this.isFromMobile = false;
        this.state = { pharmacyLinked: false };
        const searchParams = props.location && props.location.searchParams ? queryString.parse(props.location.searchParams) : null;
        if (searchParams && searchParams.openMyChart)
            this.openMyChart = true;
        else
            this.openMyChart = false;
        if (searchParams && searchParams.openPharmacy)
            this.openPharmacy = true;
        else
            this.openPharmacy = false;
        if (searchParams && searchParams.openInsurance)
            this.openInsurance = true;
        else
            this.openInsurance = false;
        if (searchParams && searchParams.openEmployee)
            this.openEmployee = true;
        else
            this.openEmployee = false;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.LinkedAccounts.ComponentDidMount", new Date(), Tools.getURLPath());
        this.isFromMobile = this.isMobileQueryValue || Tools.getItemFromSessionStorage('isMobile') || this.props.MobileOnQueryString;
    }

    render() {
        const { serverData, isProxyUser, MobileOnQueryString,
            epicEHRDown, hasMyChart, linkMyChartSuccessMessage, unlinkMyChartSuccessMessage,
            aalDown, hasAAL, linkAASuccess, unLinkAASuccess, linkEmployeeSuccessMessage, unlinkEmployeeSuccessMessage,
            swhpDown, hasHealthPlanLogin,
            hasFirstCare, linkFirstCare, unlinkFirstCare, hasDART, hasWACO, wacoMembershipId, dartMembershipId,
            linkHP, unlinkHP, linkDart, unlinkDart, linkWaco, unlinkWaco, isMyChartInActive
        } = this.props;
        //let regError = true; //Task 36729: uncommand to test error page

        let pharmacyLinkingSuccess = "We've successfully linked your account.";

        return (
            <div className="container-fluid body-content linked-accounts-container full-width">
                {this.isFromMobile && (linkMyChartSuccessMessage || unlinkMyChartSuccessMessage) ?
                    <div className="row">
                        <div className="col-12">
                            <StatusBanner bannerMsg={linkMyChartSuccessMessage || unlinkMyChartSuccessMessage} />
                        </div>
                    </div>
                    :
                    this.isFromMobile && (linkHP?.successMessage || unlinkHP?.successMessage) ?
                        <div className="row">
                            <div className="col-12">
                                <StatusBanner bannerMsg={linkHP?.successMessage || unlinkHP?.successMessage} />
                            </div>
                        </div> :
                        this.isFromMobile && (linkAASuccess || unLinkAASuccess) ?
                            <div className="row">
                                <div className="col-12">
                                    <StatusBanner bannerMsg={linkAASuccess || unLinkAASuccess} />
                                </div>
                            </div> :
                            this.isFromMobile && (linkEmployeeSuccessMessage || unlinkEmployeeSuccessMessage) ?
                                <div className="row">
                                    <div className="col-12">
                                        <StatusBanner bannerMsg={linkEmployeeSuccessMessage || unlinkEmployeeSuccessMessage} />
                                    </div>
                                </div> :
                                this.isFromMobile && this.state.pharmacyLinked ?
                                    <div className="row">
                                        <div className="col-12">
                                            <StatusBanner bannerMsg={pharmacyLinkingSuccess} />
                                        </div>
                                    </div> :
                                    <div className="row">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row page-heading-container--dt">
                                                <div className="col-12 col-md-6">
                                                    <h1 className="page-heading">Linked Accounts and Devices</h1>
                                                </div>
                                                {!this.isFromMobile && <div className="col-12 col-md-6 text-md-right">
                                                    <div className="mychart-btn-container--full-width bswh-mychart-overlay">
                                                        {(isMyChartInActive || epicEHRDown)
                                                            ? <button className="btn btn-primary" type="button" disabled={isMyChartInActive || epicEHRDown}>
                                                                LINKED DEVICES
                                                            </button>
                                                            : <Link className="btn btn-primary" to={{ pathname: "/linkeddevices" }}>
                                                                LINKED DEVICES
                                                            </Link>
                                                        }
                                                    </div>
                                                </div>}
                                            </div>
                                            <div className="row page-heading-container--dt">
                                                <div className="col-12 col-md-6">
                                                    {!isProxyUser && <h2 className="page-heading section-heading">Accounts</h2>}
                                                </div>
                                            </div>
                                            {isProxyUser ? <SectionLoadingError message="This feature is not available." sectionErrorClass="not-available-error" titleIcon="icon-log-out" /> :
                                                <React.Fragment>
                                                    <InsurancePlan
                                                        aal={hasAAL}
                                                        hasFirstCare={hasFirstCare}
                                                        hasHealthPlanLogin={hasHealthPlanLogin}
                                                        openInsurance={this.openInsurance}
                                                        hasDART={hasDART}
                                                        hasWACO={hasWACO}
                                                    />
                                                    {(hasAAL || linkAASuccess) && !unLinkAASuccess && serverData.enableAA && <LinkAAAccount />}
                                                    {serverData.enableNewHealthPlan && (hasFirstCare || (linkFirstCare && linkFirstCare.success)) && (!unlinkFirstCare || !unlinkFirstCare.success) &&
                                                        <FirstCareAccount />
                                                    }
                                                    {(hasHealthPlanLogin || (linkHP?.success)) && !(unlinkHP?.success) && <LinkHealthPlanAccount healthPlanName="Baylor Scott & White Health Plan" />}
                                                    {(hasDART || (linkDart && linkDart.success)) && !(unlinkDart && unlinkDart.success) && <DartOrWacoAccount healthPlanName="DART" memberId={dartMembershipId} />}
                                                    {(hasWACO || (linkWaco && linkWaco.success)) && !(unlinkWaco && unlinkWaco.success) && <DartOrWacoAccount healthPlanName="City of Waco" memberId={wacoMembershipId} />}
                                                    <LinkMyChartAccount openMyChart={this.openMyChart} />
                                                    <LinkEmployeeAccount openEmployee={this.openEmployee} />
                                                    <LinkPharmacy onLinked={() => this.setState({ pharmacyLinked: true })} openPharmacy={this.openPharmacy} />
                                                </React.Fragment>
                                            }
                                        </div>
                                    </div>
                }
            </div>
            // }
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    return {
        UserName: state.domain.un,
        hasMyChart: state.domain.hm,
        hasAAL: state.memberships.hasAA,
        hasHealthPlanLogin: state.memberships.hasAnySWHP,
        hasFirstCare: state.memberships.hasFC,

        hasDART: state.memberships.hasDART,
        hasWACO: state.memberships.hasWACO,
        wacoMembershipId: state.memberships.wacoMembershipId,
        dartMembershipId: state.memberships.dartMembershipId,
        epicEHRDown: state.common.epicEHRDown,
        aalDown: state.common.aalDown,
        swhpDown: state.common.swhpDown,
        serverData: state.session.serverData,
        isProxyUser: state.domain.ip,
        MobileOnQueryString: state.domain.mq,
        linkMyChartSuccessMessage: state.healthSource.linkMyChartSuccessMessage,
        unlinkMyChartSuccessMessage: state.healthSource.unlinkMyChartSuccessMessage,
        linkEmployeeSuccessMessage: state.healthSource.linkEmployeeSuccessMessage,
        unlinkEmployeeSuccessMessage: state.healthSource.unlinkEmployeeSuccessMessage,
        linkAASuccess: state.healthPlan.linkAASuccess,
        unLinkAASuccess: state.healthPlan.unLinkAASuccess,
        linkHP: state.healthPlan.linkHP,
        unlinkHP: state.healthPlan.unlinkHP,
        linkFirstCare: state.healthPlan.linkFirstCare,
        unlinkFirstCare: state.healthPlan.unlinkFirstCare,
        linkDart: state.healthPlan.linkDart,
        unlinkDart: state.healthPlan.unlinkDart,
        linkWaco: state.healthPlan.linkWaco,
        unlinkWaco: state.healthPlan.unlinkWaco,
        isMyChartInActive: state.dashboard.isMyChartInActive
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkedAccounts);